export const PATH = "depo";

export const MOBILE_WIDTH = 800;

export const ROLE = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
};

export const MODULE_SLUGS = {
  DASHBOARD: "dashboard",
  OPEN_SALES_ORDERS: "open-sales-orders",
  INVOICES: "invoices",
  MANAGE_ROLES: "manage-roles",
  MANAGE_USERS: "manage-users",
  MANAGE_DEPOTS: "manage-depots",

  // WMS Modules
  MANAGE_COMPANIES: "manage-companies",
  WAREHOUSE_LAYOUT: "warehouse-layout",
  MANAGE_CUSTOMERS: "manage-customers",
  MANAGE_SUPPLIERS: "manage-suppliers",
  GST_CONFIG: "gst-configuration",
  NUMBER_SERIES: "number-series",
  SYSTEM_CONFIG: "system-config",
  PURCHASE_REQUESTS: "purchase-requests",
  PURCHASE_ORDERS: "purchase-orders",
  GOODS_RECEIPT: "goods-receipt",
  STO_RECEIPT: "sto-receipt",
  BATCHES: "batches",
  STOCK_MANAGEMENT: "stock-management",

  // Phase 2 - Sales
  SALES_ORDERS: "sales-orders",
  PICKING: "picking",
  DISPATCH: "dispatch",
  WMS_INVOICES: "wms-invoices",
  CREDIT_DEBIT_NOTES: "credit-debit-notes",
  PAYMENTS: "payments",
  SALES_RETURNS: "sales-returns",

  // Phase 3 - Warehouse Operations
  PUTAWAY: "putaway",
  SHELF_TRANSFERS: "shelf-transfers",
  CYCLE_COUNTS: "cycle-counts",
  STOCK_TRANSFERS: "stock-transfers",
  STOCK_LEVELS: "stock-levels",
  EXPIRY_MANAGEMENT: "expiry-management",

  // Retail (depot counter sales to AB / RB / DW / Normal)
  SALE_BILLS: "sale-bills",
};

export const PERMISSIONS = {
  VIEW: "view",
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete",
  EXPORT: "export",
};

export const INVOICE_STATUS = {
  DRAFT: "draft",
  CONFIRMED: "confirmed",
  CANCELLED: "cancelled",
};

export const INVOICE_STATUS_COLORS = {
  draft: "blue",
  confirmed: "green",
  cancelled: "red",
};

export const PO_STATUS = {
  DRAFT: "draft",
  APPROVED: "approved",
  PARTIALLY_RECEIVED: "partially_received",
  RECEIVED: "received",
  CANCELLED: "cancelled",
};

export const PR_STATUS_COLORS = {
  draft: "blue",
  approved: "green",
  rejected: "red",
  converted: "cyan",
};

export const PO_STATUS_COLORS = {
  draft: "blue",
  approved: "green",
  partially_received: "orange",
  received: "cyan",
  cancelled: "red",
};

export const GRN_STATUS = {
  DRAFT: "draft",
  COMPLETED: "completed",
};

export const GRN_STATUS_COLORS = {
  draft: "blue",
  completed: "green",
};

export const BATCH_STATUS_COLORS = {
  active: "green",
  expired: "red",
  recalled: "orange",
  quarantined: "purple",
};

export const STOCK_TYPE_COLORS = {
  available: "green",
  reserved: "blue",
  qc_hold: "orange",
  damaged: "red",
  blocked: "volcano",
  in_transit: "cyan",
};

export const MOVEMENT_TYPE_COLORS = {
  grn_in: "green",
  sale_out: "blue",
  transfer_in: "cyan",
  transfer_out: "geekblue",
  adjustment_positive: "lime",
  adjustment_negative: "orange",
  return_in: "purple",
};

export const CUSTOMER_TYPE_OPTIONS = [
  { label: "General Store", value: "general_store" },
  { label: "Supermarket", value: "supermarket" },
  { label: "Modern Trade", value: "modern_trade" },
  { label: "Institutional", value: "institutional" },
  { label: "HoReCa", value: "horeca" },
  { label: "Marketplace", value: "marketplace" },
  { label: "D2C", value: "d2c" },
  { label: "Wholesaler", value: "wholesaler" },
];

export const SUPPLIER_TYPE_OPTIONS = [
  { label: "Manufacturer", value: "manufacturer" },
  { label: "Distributor", value: "distributor" },
  { label: "Importer", value: "importer" },
  { label: "Service Provider", value: "service_provider" },
  { label: "Transporter", value: "transporter" },
];

export const PAYMENT_TERMS_OPTIONS = [
  { label: "Advance", value: "advance" },
  { label: "Cash on Delivery", value: "cod" },
  { label: "Credit 7 Days", value: "credit_7" },
  { label: "Credit 15 Days", value: "credit_15" },
  { label: "Credit 30 Days", value: "credit_30" },
  { label: "Credit 45 Days", value: "credit_45" },
  { label: "Credit 60 Days", value: "credit_60" },
];

export const ZONE_TYPE_OPTIONS = [
  { label: "Ambient", value: "ambient" },
  { label: "Cold", value: "cold" },
  { label: "Frozen", value: "frozen" },
  { label: "Hazardous", value: "hazardous" },
  { label: "Returns", value: "returns" },
  { label: "QC Hold", value: "qc_hold" },
  { label: "Staging", value: "staging" },
];

export const BIN_TYPE_OPTIONS = [
  { label: "Picking", value: "picking" },
  { label: "Bulk", value: "bulk" },
  { label: "Staging Inbound", value: "staging_inbound" },
  { label: "Staging Outbound", value: "staging_outbound" },
  { label: "QC Hold", value: "qc_hold" },
  { label: "Damaged", value: "damaged" },
  { label: "Returns", value: "returns" },
];

export const DOCUMENT_TYPE_OPTIONS = [
  { label: "Invoice", value: "invoice" },
  { label: "Credit Note", value: "credit_note" },
  { label: "Purchase Order", value: "purchase_order" },
  { label: "GRN", value: "grn" },
  { label: "Stock Transfer", value: "stock_transfer" },
  { label: "Debit Note", value: "debit_note" },
  { label: "Delivery Challan", value: "delivery_challan" },
  { label: "Sales Order", value: "sales_order" },
  { label: "Pick List", value: "pick_list" },
  { label: "Dispatch", value: "dispatch" },
  { label: "WMS Invoice", value: "wms_invoice" },
  { label: "Payment", value: "payment" },
  { label: "Sales Return", value: "sales_return" },
  { label: "Putaway", value: "putaway" },
  { label: "Shelf Transfer", value: "shelf_transfer" },
  { label: "Cycle Count", value: "cycle_count" },
  { label: "Stock Transfer", value: "stock_transfer" },
];

// Phase 2 - Sales Order Status
export const SO_STATUS = {
  CREATED: "created",
  APPROVED: "approved",
  ALLOCATED: "allocated",
  PICKING: "picking",
  PICKED: "picked",
  PACKED: "packed",
  INVOICED: "invoiced",
  DISPATCHED: "dispatched",
  DELIVERED: "delivered",
  PARTIAL_DELIVERED: "partial_delivered",
  CANCELLED: "cancelled",
};

export const SO_STATUS_COLORS = {
  created: "blue",
  approved: "green",
  allocated: "geekblue",
  picking: "orange",
  picked: "cyan",
  packed: "purple",
  invoiced: "gold",
  dispatched: "lime",
  delivered: "green",
  partial_delivered: "orange",
  cancelled: "red",
};

export const SO_SOURCE_OPTIONS = [
  { label: "Manual", value: "manual" },
  { label: "Store Portal", value: "store_portal" },
  { label: "E-commerce", value: "ecommerce" },
  { label: "Bulk Upload", value: "bulk_upload" },
];

export const ORDER_PRIORITY_OPTIONS = [
  { label: "Normal", value: "normal" },
  { label: "High", value: "high" },
  { label: "Urgent", value: "urgent" },
];

export const ORDER_PRIORITY_COLORS = {
  normal: "blue",
  high: "orange",
  urgent: "red",
};

export const PICK_STATUS = {
  CREATED: "created",
  ASSIGNED: "assigned",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
};

export const PICK_STATUS_COLORS = {
  created: "blue",
  assigned: "geekblue",
  in_progress: "orange",
  completed: "green",
};

export const DISPATCH_STATUS = {
  LOADING: "loading",
  DISPATCHED: "dispatched",
  DELIVERED: "delivered",
  PARTIAL_DELIVERED: "partial_delivered",
  RETURNED: "returned",
};

export const DISPATCH_STATUS_COLORS = {
  loading: "blue",
  dispatched: "orange",
  delivered: "green",
  partial_delivered: "gold",
  returned: "red",
};

export const PAYMENT_MODE_OPTIONS = [
  { label: "Cash", value: "cash" },
  { label: "Cheque", value: "cheque" },
  { label: "NEFT/RTGS", value: "neft_rtgs" },
  { label: "UPI", value: "upi" },
  { label: "Advance", value: "advance" },
  { label: "Credit Adjustment", value: "credit_adjustment" },
];

export const PAYMENT_STATUS = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  BOUNCED: "bounced",
  CANCELLED: "cancelled",
};

export const PAYMENT_STATUS_COLORS = {
  pending: "blue",
  confirmed: "green",
  bounced: "red",
  cancelled: "volcano",
};

export const CN_TYPE_OPTIONS = [
  { label: "Sales Return", value: "sales_return" },
  { label: "Rate Difference", value: "rate_difference" },
  { label: "Scheme Credit", value: "scheme_credit" },
  { label: "Post Sale Discount", value: "post_sale_discount" },
];

export const CN_STATUS_COLORS = {
  draft: "blue",
  approved: "green",
  cancelled: "red",
};

export const DN_TYPE_OPTIONS = [
  { label: "Price Increase", value: "price_increase" },
  { label: "Additional Charges", value: "additional_charges" },
  { label: "Short Payment", value: "short_payment" },
];

export const DN_STATUS_COLORS = {
  draft: "blue",
  approved: "green",
  cancelled: "red",
};

export const RETURN_STATUS = {
  INITIATED: "initiated",
  RECEIVED: "received",
  INSPECTED: "inspected",
  COMPLETED: "completed",
  REJECTED: "rejected",
};

export const RETURN_STATUS_COLORS = {
  initiated: "blue",
  received: "geekblue",
  inspected: "orange",
  completed: "green",
  rejected: "red",
};

export const TAX_TYPE_OPTIONS = [
  { label: "CGST + SGST", value: "CGST_SGST" },
  { label: "IGST", value: "IGST" },
];

export const ITEM_CONDITION_OPTIONS = [
  { label: "Good", value: "good" },
  { label: "Damaged", value: "damaged" },
  { label: "Expired", value: "expired" },
];

// Phase 3 - Putaway Status
export const PUTAWAY_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const PUTAWAY_STATUS_COLORS = {
  pending: "blue",
  in_progress: "orange",
  completed: "green",
  cancelled: "red",
};

// Phase 3 - Shelf Transfer Status
export const SHELF_TRANSFER_STATUS = {
  DRAFT: "draft",
  APPROVED: "approved",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const SHELF_TRANSFER_STATUS_COLORS = {
  draft: "blue",
  approved: "green",
  completed: "cyan",
  cancelled: "red",
};

// Phase 3 - Cycle Count Status
export const CYCLE_COUNT_STATUS = {
  DRAFT: "draft",
  IN_PROGRESS: "in_progress",
  COUNTED: "counted",
  APPROVED: "approved",
  ADJUSTED: "adjusted",
  CANCELLED: "cancelled",
};

export const CYCLE_COUNT_STATUS_COLORS = {
  draft: "blue",
  in_progress: "orange",
  counted: "geekblue",
  approved: "green",
  adjusted: "cyan",
  cancelled: "red",
};

// Phase 3 - Stock Transfer Status
export const TRANSFER_STATUS = {
  DRAFT: "draft",
  APPROVED: "approved",
  DISPATCHED: "dispatched",
  IN_TRANSIT: "in_transit",
  RECEIVED: "received",
  PARTIAL_RECEIVED: "partial_received",
  CANCELLED: "cancelled",
};

export const TRANSFER_STATUS_COLORS = {
  draft: "blue",
  approved: "green",
  dispatched: "orange",
  in_transit: "geekblue",
  received: "cyan",
  partial_received: "gold",
  cancelled: "red",
};

export const USER_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const MESSAGES = {
  API_ERROR: "Something went wrong. Please try again.",
  LOGIN_SUCCESS: "Login successful",
  LOGOUT_SUCCESS: "Logged out successfully",
};

export const depoNotificationSuccessConf = {
  variant: "success",
  placement: "topRight",
  duration: 3,
};

export const depoNotificationErrorConf = {
  variant: "error",
  placement: "topRight",
  // Errors often carry multi-line detail (brand-restriction blocks,
  // stock shortages, validation lists). 3s is too fast to read those —
  // 8s gives the operator time before the toast dismisses.
  duration: 8,
};

export const depoNotificationWarningConf = {
  variant: "warning",
  placement: "topRight",
  duration: 3,
};

export const DATEFORMAT = "DD/MM/YYYY";
export const DATETIMEFORMAT = "DD/MM/YYYY hh:mm A";

/**
 * Check if user has a specific permission for a module
 */
export const hasPermission = (modulePermissions, moduleSlug, permission) => {
  if (!modulePermissions) return false;
  const mod = modulePermissions.find((m) => m.module_slug === moduleSlug);
  if (!mod) return false;
  return mod.permissions?.includes(permission) || false;
};
